var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"home"}},[(_vm.show)?_c('menuPage',{staticClass:"sidebar"}):_vm._e(),_c('div',{staticClass:"content"},[_c('router-view',{staticClass:"view",attrs:{"element-loading-spinner":"el-icon-loading"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }